module.exports = {
    en: {
        path: 'en',
        locale: 'English',
        default: true
    },
    ko: {
        path: 'ko',
        locale: '한국어'
    },
    zh: {
        path: 'zh',
        locale: '中文'
    }

}